import { render, staticRenderFns } from "./ChatGroupMember.vue?vue&type=template&id=d12fb3e0&scoped=true"
import script from "./ChatGroupMember.vue?vue&type=script&lang=js"
export * from "./ChatGroupMember.vue?vue&type=script&lang=js"
import style0 from "./ChatGroupMember.vue?vue&type=style&index=0&id=d12fb3e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12fb3e0",
  null
  
)

export default component.exports